<script lang="ts">
    import type { DialogFieldCustom } from "ceyper-common";

    export let field: DialogFieldCustom;

    let files: FileList;
    let preview = "";

    $: files, updateFile();
    function updateFile() {
        if (!files) return;

        const file = files?.[0];
        if (!file) return;

        const url = URL.createObjectURL(file);
        preview = url;

        const img = new Image();
        img.src = url;

        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d")!;
            ctx.drawImage(img, 0, 0);

            // Set result
            field.value = ctx.getImageData(0, 0, img.width, img.height);
        };
    }
</script>

<!----------------------------------------------------------------------------->

<span>{field.label}</span>

<label>
    <input accept="image/*" bind:files name={field.label} type="file" />

    {#if preview}
        <img class="preview" src={preview} alt="upload" />
    {:else}
        <div class="preview empty" />
    {/if}
</label>

<!----------------------------------------------------------------------------->

<style>
    input {
        display: none;
    }

    .preview {
        min-width: 8em;
        width: 100%;
        height: 8em;
        border: 1px solid var(--g400);
        object-fit: contain;
        background-color: var(--g50);
        box-sizing: border-box;

        display: grid;
        place-content: center;
        text-align: center;

        &.empty::before {
            content: "No image selected";
            color: var(--t400);
        }
    }
</style>
